<div class="due-date-label" (click)="showDateInput()" *ngIf="!focusInput">{{((issue.dueDate | date) ?? 'нет')}}</div>
<div class="due-date-input" *ngIf="focusInput">
  <tui-input-date
    toNativeDate
    tuiTextfieldSize="m"
    (focusedChange)="focusChange($event)"
    (ngModelChange)="updateDueDate()"
    [tuiTextfieldLabelOutside]="true"
    [formControl]="inputControl">
    Выберите дату
  </tui-input-date>
</div>
